export const ArrowIcon: React.FC<{
    className?: string;
    fillColor?: string;
    width?: number | string;
    height?: number | string;
}> = ({ className, fillColor = "#64748b", width = 8, height = 13 }) => {
	return (
		<svg
			className={className}
			fill="none"
            height={height}
			viewBox="0 0 8 13"
            width={width}
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M6.90032 0.183058C7.1222 0.404947 7.14238 0.752167 6.96083 0.996843L6.90032 1.06694L1.50921 6.45833L6.90032 11.8497C7.1222 12.0716 7.14238 12.4188 6.96083 12.6635L6.90032 12.7336C6.67843 12.9555 6.33121 12.9757 6.08653 12.7941L6.01643 12.7336L0.183098 6.90027C-0.0387905 6.67839 -0.0589621 6.33117 0.122583 6.08649L0.183099 6.01639L6.01643 0.183058C6.26051 -0.0610195 6.65624 -0.0610194 6.90032 0.183058Z"
                fill={fillColor}
			/>
		</svg>
	);
};
